$(document).ready(function() {

    $('.description__section').each(function(){
        let imagesCount =Array.from( $(this).find('.img__container')).length / 2;
    
        $(this).addClass(`description__section-${imagesCount}`)
    
    })

})